import { IGlobalState } from '../../Root/store/appReducer'

export const getLoadingJoinGoal = (state: IGlobalState) => state.loading.joinGoal
